import { render, staticRenderFns } from "./ContestacoesWebcheckout.vue?vue&type=template&id=fb7e9676&scoped=true&"
import script from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
export * from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
import style0 from "./ContestacoesWebcheckout.vue?vue&type=style&index=0&id=fb7e9676&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7e9676",
  null
  
)

export default component.exports